import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router';
import type { Database, Project } from '@tallypg/contracts';
import { api, formatBytes, formatMoney, useApi } from '../api';
import { StatusBadge } from '../components';
import { CreateDatabaseWizard } from './Databases';

export function ProjectDetailPage() {
  const { projectId } = useParams();
  const nav = useNavigate();
  const data = useApi<{ project: Project; databases: Database[] }>(`/projects/${projectId}`);
  const [error, setError] = useState<string | null>(null);
  if (data.error) return <p className="error">{data.error.message}</p>;
  if (!data.data) return <p className="muted">Loading…</p>;
  const { project, databases } = data.data;
  return (
    <div>
      <p className="muted">
        <Link to="/projects">Projects</Link> / {project.name}
      </p>
      <div className="row between">
        <h1>{project.name}</h1>
        <button
          className="danger"
          onClick={async () => {
            if (!confirm(`Delete project "${project.name}"? It must be empty.`)) return;
            try {
              await api(`/projects/${project.id}`, { method: 'DELETE' });
              nav('/projects');
            } catch (err) {
              setError(err instanceof Error ? err.message : 'Failed');
            }
          }}
        >
          Delete project
        </button>
      </div>
      {error && <p className="error">{error}</p>}
      <div className="card">
        <h2>New database in this project</h2>
        <CreateDatabaseWizard projectId={project.id} onCreated={() => void data.reload()} />
      </div>
      <div className="card">
        <h2>Databases</h2>
        {databases.length === 0 && <p className="muted">No databases in this project yet.</p>}
        {databases.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Size</th>
                <th>This month</th>
              </tr>
            </thead>
            <tbody>
              {databases.map((d) => (
                <tr key={d.id}>
                  <td>
                    <Link to={`/databases/${d.id}`}>{d.name}</Link>
                  </td>
                  <td>
                    <StatusBadge state={d.state} />
                  </td>
                  <td>{formatBytes(d.sizeBytes)}</td>
                  <td>{formatMoney(d.monthToDateMicroUsd)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
